(function() {
	'use strict';

	angular.module('quantixApp').factory('industryService', industryService);

	industryService.$inject = [ '$http', '$q' ];

	function industryService($http, $q) {

		var _getRatingDetails = function(industryId) {

			var deferred = $q.defer();

			var url = 'api/industryProfileRating/getRatingDetails';

			$http.post(url, {
				searchText : industryId
			}, {
				ignoreLoadingBar : true
			}).then(function(response) {

				deferred.resolve(response.data);

			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;

		}

		var _getAggFinancials = function(industryId) {

			var deferred = $q.defer();

			var url = 'api/industryProfile/getIndustryAggregates';

			$http.post(url, {
				searchText : industryId
			}, {
				ignoreLoadingBar : false
			}).then(function(response) {

				deferred.resolve(response.data);

			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;
		}

		var _getAggQuaters = function(industryId) {

			var deferred = $q.defer();

			var url = 'api/industryProfile/getAggQuaters';

			$http.post(url, {
				searchText : industryId
			}, {
				ignoreLoadingBar : false
			}).then(function(response) {

				deferred.resolve(response.data);

			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;
		}

		var _saveAlerts = function(data) {
			var deferred = $q.defer();
			var url = 'api/industryProfile/saveAlerts';

			$http.post(url, data, {
				ignoreLoadingBar : true
			}).then(function(response) {

				deferred.resolve(response.data);

			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;
		}

		var _getDataForPieChart = function(type) {

			var deferred = $q.defer();

			var url = 'api/industryProfile/getPieChartData';

			//$http.post(url, {indID : compId}).then(function(response) {

			$http.post(url, {
				indID : type
			}, {
				ignoreLoadingBar : true
			}).then(function(response) {
				deferred.resolve(response);

			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;

		}

		//var _getCompanyDetailsForRatingChart = function(compId) {
		var _getCompanyDetailsForRatingChart = function() {
			var deferred = $q.defer();

			var url = 'api/industryProfile/getRatingChartData';

			//$http.post(url, {indID : compId}).then(function(response) {
			$http.post(url, {
				ignoreLoadingBar : true
			}).then(function(response) {
				deferred.resolve(response);

			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;
		}

		var _getRecentUpdates = function() {
			var deferred = $q.defer();

			var url = 'api/industryProfile/getRecentUpdates';

			$http.post(url, {
				ignoreLoadingBar : true
			}).then(function(response) {
				deferred.resolve(response);

			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;
		}

		var _getIndustriesListByName = function(searchText) {

			var deferred = $q.defer();

			var url = 'api/industryProfile/getIndustries';

			$http.post(url, {
				searchText : searchText
			}, {
				ignoreLoadingBar : true
			}).then(function(response) {
				deferred.resolve(response);

			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;
		}

		var _getRecentlyViewed = function(indInfo) {

			var deferred = $q.defer();

			var url = 'api/industryProfile/saveRecentlyViewed';

			$http.post(url, {
				indInfo : indInfo
			}, {
				ignoreLoadingBar : true
			}).then(function(response) {
				deferred.resolve(response);

			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;
		}

		var _addToFavorites = function(obj) {

			var deferred = $q.defer();

			var url = 'api/industryProfile/addToFavorites';

			$http.post(url, {
				favorites : obj
			}, {
				ignoreLoadingBar : true
			}).then(function(response) {
				deferred.resolve(response);

			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;
		}

		var _getIndustryInfo = function(id) {

			var deferred = $q.defer();

			var url = 'api/industryProfileLanding/getIndustryInfo';

			$http.post(url, {
				industryId : id
			}, {
				ignoreLoadingBar : true
			}).then(function(response) {
				deferred.resolve(response);

			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;
		}
		//yash
		var _getConstituentdata = function(page, industry) {

			var deferred = $q.defer();

			var pageNum = 0;

			var url = 'api/industryProfileLanding/getConstituentdata';

			$http.post(url, {
				industryId : industry,
				pageNumber : page
			}, {
				ignoreLoadingBar : true
			}).then(function(response) {
				deferred.resolve(response);

			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;
		}

		var _getFinancialsInfo = function(page, id, type) {

			var deferred = $q.defer();

			var url = 'api/industryProfileLanding/getFinancialsInfo';

			$http.post(url, {
				industryId : id,
				industryType : type,
				pageNumber : page
			}, {
				ignoreLoadingBar : true
			}).then(function(response) {
				deferred.resolve(response);

			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;
		}

		//yash

		var _getClusterInfo = function(id) {

			var deferred = $q.defer();

			var url = 'api/industryProfile/getClusterInfo';

			$http.post(url, {
				industryId : id
			}, {
				ignoreLoadingBar : true
			}).then(function(response) {
				deferred.resolve(response);

			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;

		}

		var _getClusterInfoByIndustryName = function(id, cityName) {

			var deferred = $q.defer();
			var fd = new FormData();
			var url = 'api/industryProfile/getIndustriesByName';
			fd.append('industryId', id);
			fd.append('cityName', cityName);

			$http.post(url, fd, {
				transformRequest : angular.identity,
				headers : {
					'Content-Type' : undefined
				}
			}, {
				ignoreLoadingBar : true
			}).then(function(response) {
				deferred.resolve(response);

			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;

		}

		var _getRatingHistory = function(obj) {
			var deferred = $q.defer();

			var url = 'api/industryProfile/getRatingHistory';

			$http.post(url, {
				multidata : obj
			}, {
				ignoreLoadingBar : true
			}).then(function(response) {
				deferred.resolve(response);

			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;
		}
		
		var _generateHtmltreegridDataExport = function(htmltreegridData) {

			var deferred = $q.defer();
			$http.post('api/industryProfile/htmltreegridexportdataExcel',
					htmltreegridData, {
						responseType : 'arraybuffer'
					}).then(function(response) {

				deferred.resolve(response.data);

			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;
		}

		return {
			getRatingDetails : _getRatingDetails,
			getIndustryInfo : _getIndustryInfo,
			getClusterInfo : _getClusterInfo,
			addToFavorites : _addToFavorites,
			getRecentlyViewed : _getRecentlyViewed,
			getIndustriesListName : _getIndustriesListByName,
			getDetailsForRatingChart : _getCompanyDetailsForRatingChart,
			getAggFinancials : _getAggFinancials,
			getAggQuaters : _getAggQuaters,
			getDataForPieChart : _getDataForPieChart,
			getRecentUpdates : _getRecentUpdates,
			saveAlerts : _saveAlerts,
			getClusterInfoByIndustryName : _getClusterInfoByIndustryName,
			//yash
			getConstituentInfo : _getConstituentdata,
			getFinancialsInfo : _getFinancialsInfo,

			//yash
			//kaushal
			getRatingHistory : _getRatingHistory,
			generateHtmltreegridDataExport : _generateHtmltreegridDataExport
		};
	}
})();
